import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { SessionStorageService } from './session-storage.service';
import { OAuthConstants } from 'src/app/oauth/constant/oAuth.constants';

@Injectable({
    providedIn: 'root'
})
export class LoginChallengeDataService {
    constructor(private _sessionStorageService: SessionStorageService) { }
    private _loginChallengeSource = new Subject<string>();
    public loginChallengeSource: Observable<string> = this._loginChallengeSource.asObservable();

    public setLoginChallenge(value): void {
        this._sessionStorageService.put(OAuthConstants.LOGIN_CHALLENGE, value);
        this._loginChallengeSource.next(value);
    }
    public getLoginChallenge(): string {
        return this._sessionStorageService.value(OAuthConstants.LOGIN_CHALLENGE) || '';
    }
}
